export const environment = {
  production: true,
  apiUrl: 'https://api-dev.eliso.fsf.tools',
  mockApi: false,
  googleMaps: {
    apiKey: 'AIzaSyCLc-Zvbbk37bBJ89Yz_h_4rXsKGOMZqHo',
    center: { lat: 51.165691, lng: 10.451526 },
    zoom: 6,
  },
};
